import React from 'react';

import { useTranslation } from '@splitfiesta/i18n';
import { SplitMethod } from '@splitfiesta/shared';
import { Button } from '@splitfiesta/ui';

import { SplitCalculationResult } from './types';

interface SplitAmountCalculatorProps {
  splitMethod: SplitMethod;
  includedSplitsCount: number;
  calculationResult: SplitCalculationResult;
  onSplitEvenly: () => void;
  onAutoComplete: () => void;
  isLoading?: boolean;
}

export function SplitAmountCalculator({
  splitMethod,
  includedSplitsCount,
  calculationResult,
  onSplitEvenly,
  onAutoComplete,
  isLoading = false,
}: SplitAmountCalculatorProps) {
  const { t } = useTranslation();

  // Don't show action buttons for equal or shares split methods (they always allocate 100%)
  if (
    splitMethod === 'equal' ||
    splitMethod === 'shares' ||
    includedSplitsCount === 0
  ) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 gap-2 sm:flex sm:gap-2">
      <Button
        variant="secondary"
        size="sm"
        type="button"
        onClick={onSplitEvenly}
        disabled={isLoading}
        className="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 font-medium"
      >
        {t('groups:defaultSplit.distributeEqually')}
      </Button>
      {calculationResult.canAutoComplete && (
        <Button
          variant="secondary"
          size="sm"
          type="button"
          onClick={onAutoComplete}
          disabled={isLoading}
          className="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 font-medium"
        >
          {t('expenses:actions.fillInTheRest')}
        </Button>
      )}
    </div>
  );
}
